import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as API from "../../../Utils/Services/api";
import { useParams } from "react-router-dom";
import { collectFees, onLockCollectFees } from "../../../helpers/v3/v3";
import "./ViewPositions.css";
import Loading from "../../Loading/Loading";
import { ADDRS } from "../../../Contracts/V3/addresses";
import { useLanguage } from "../../LanguageContext";
import translation from "../../Translations/translation.json";

const ViewPositionsV3 = () => {
  // const { walletAddress } = useParams();
  const [accountAvailable, setAccountAvailable] = useState(
    sessionStorage.getItem("account")
  );
  const { language } = useLanguage();
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collectingId, setCollectingId] = useState(null);
  // const [feesByTokenId, setFeesByTokenId] = useState({});
  // const [viewingId, setViewingId] = useState(null);
  const loadPositions = async () => {
    if (!accountAvailable) toast.warn(translate("banner.connectmetamask"));
    try {
      setLoading(true);

      const res = await API.getViewPositionV3(accountAvailable);
      const data = res.data || {};

      setPositions(data.tokens);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setAccountAvailable(sessionStorage.getItem("account"));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    loadPositions();
  }, [accountAvailable]);

  const handleCopy = (value) => {
    if (!value) return;
    navigator.clipboard.writeText(String(value));
    toast.success(translate("copiedSuccessfully"));
  };
  // const handleViewUncollected = async (tokenId) => {
  //   if (!tokenId) return;
  //   try {
  //     setViewingId(tokenId);
  //     const fees = await loadUncollectedForPosition(tokenId);
  //     console.log(fees, "feessssss");
  //     if (fees) {
  //       setFeesByTokenId((prev) => ({ ...prev, [tokenId]: fees }));
  //     }
  //   } catch (e) {
  //     console.error(e);
  //     toast.error("Failed to load uncollected fees");
  //   } finally {
  //     setViewingId(null);
  //   }
  // };

  const formatFeeTier = (tier) => {
    if (!tier) return "-";
    return (tier / 10000).toFixed(2) + "%";
  };

  const onCollect = async (token) => {
    try {
      if (!token.tokenId) {
        toast.error(translate("view.missing"));
        return;
      }
      setCollectingId(token.tokenId);

      const { tx, amount0, amount1 } = await collectFees({
        tokenId: token.tokenId,
        recipient: accountAvailable,
      });

      toast.success(translate("view.feesucc"));

      loadPositions();
    } catch (e) {
      console.error(e);
      toast.error(e?.message);
    } finally {
      setCollectingId(null);
    }
  };

  const onLockCollect = async (token) => {
    try {
      if (!token.tokenId) {
        toast.error(translate("view.missing"));
        return;
      }
      setCollectingId(token.tokenId);

      await onLockCollectFees({
        lockerAddress: ADDRS.LOCKER_ADDRESS,
        tokenId: token.tokenId,
      });

      toast.success(translate("view.feesucc"));

      loadPositions();
    } catch (e) {
      console.error(e);
      toast.error(e?.message);
    } finally {
      setCollectingId(null);
    }
  };

  return (
    <>
      <div className="view-positions-section mt-3">
        <h2>{translate("view.liquidityPositions")}</h2>
      </div>

      <div className="v3-main mt-3">
        {!accountAvailable && (
          <p style={{ textAlign: "center" }}>
            {translate("view.ConnetWalletViewLP")}
          </p>
        )}

        {accountAvailable && loading && (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Loading />
          </div>
        )}

        {accountAvailable && !loading && positions.length === 0 && (
          <div style={{ textAlign: "center" }}>
            {translate("view.nopositionFound")}
          </div>
        )}

        {/* {positions.map((p) => (
          <div key={p._id} className="view-liquidity-section">
            <div className="view-created-liquidity">
              <div className="created-liquidity-img">
                {p.image && (
                  <img
                    src={p.image}
                    alt={p.symbol}
                    className="liquidity-token-image"
                  />
                )}

                <div className="token-meta">
                  <div className="token-name">
                    {p.name} <span className="token-symbol">({p.symbol})</span>
                  </div>

                  <div className="token-address">
                    {p.address
                      ? `${p.address.slice(0, 6)}…${p.address.slice(-4)}`
                      : "-"}
                    {p.address && (
                      <i
                        className="fa fa-copy ms-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCopy(p.address)}
                      ></i>
                    )}
                  </div>
                </div>
              </div>

              <div>
                <button
                  className={`manage-liquidity-btn ${
                    collectingId === p.tokenId ? "active" : ""
                  }`}
                  onClick={() => onCollect(p)}
                  disabled={collectingId === p.tokenId}
                >
                  {collectingId === p.tokenId ? (
                    <span>
                      <Loading />
                    </span>
                  ) : (
                    "Collect Fees"
                  )}
                </button>
                {p.tokenId && (
                  <button
                    className="view-fees-btn"
                    onClick={() => handleViewUncollected(p.tokenId)}
                    disabled={viewingId === p.tokenId}
                  >
                    {viewingId === p.tokenId ? (
                      <Loading />
                    ) : p.feeTier ? (
                      "Refresh Uncollected Fees"
                    ) : (
                      "View Uncollected Fees"
                    )}
                  </button>
                )}
              </div>
            </div>

            <div className="position-extra mt-2">
              {p.tokenId && (
                <div className="position-id">
                  <span className="liquidity-pos-id">Position Id :</span>
                  <span className="liquidity-info-amt">
                    <span>{String(p.tokenId)}</span>
                    <i
                      className="fa fa-copy ms-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleCopy(p.tokenId)}
                    ></i>
                  </span>
                </div>
              )}
            </div>

            <div className="manage-all-liquidity mt-2">
              <div className="liquidty-info">
                <div className="liquidity-info-title">Fee Tier</div>
                <div className="liquidity-info-amt">
                  {formatFeeTier(p.feeTier)}
                </div>
              </div>

              <div className="liquidty-info">
                <div className="liquidity-info-title">Liquidity Added</div>
                <div className="liquidity-info-amt">
                  {p.ethwAmount ?? "0"} ETHW{" / "}
                  {p.tokenAmount ?? "0"} {p.symbol}
                </div>
              </div>
            </div>
          </div>
        ))} */}

        {accountAvailable &&
          !loading &&
          positions.map((p) => {
            // const tokenId = p.tokenId;
            // const fees = tokenId ? feesByTokenId?.[tokenId] : null;

            return (
              <div key={p._id} className="view-liquidity-section">
                <div className="view-created-liquidity">
                  <div className="created-liquidity-img">
                    {p.image && (
                      <img
                        src={p.image}
                        alt={p.symbol}
                        className="liquidity-token-image"
                      />
                    )}

                    <div className="token-meta">
                      <div className="token-name">
                        {p.name}{" "}
                        <span className="token-symbol">({p.symbol})</span>
                      </div>

                      <div className="token-address">
                        {p.address
                          ? `${p.address.slice(0, 6)}…${p.address.slice(-4)}`
                          : "-"}
                        {p.address && (
                          <i
                            className="fa fa-copy ms-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleCopy(p.address)}
                          ></i>
                        )}
                      </div>
                    </div>
                    {p.isLocked && (
                      <div style={{ marginLeft: "20px" }}>
                        <img
                          src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1759556826/Group_111_kkgk9n.svg"
                          alt="lock"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div>
                    {p.isLocked ? (
                      <button
                        className={`manage-liquidity-btn ${
                          collectingId === p.tokenId ? "active" : ""
                        }`}
                        onClick={() => onLockCollect(p)}
                        disabled={collectingId === p.tokenId}
                      >
                        {collectingId === p.tokenId ? (
                          <span>
                            <Loading />
                          </span>
                        ) : (
                          <span> {translate("view.collectFees")}</span>
                        )}
                      </button>
                    ) : (
                      <button
                        className={`manage-liquidity-btn ${
                          collectingId === p.tokenId ? "active" : ""
                        }`}
                        onClick={() => onCollect(p)}
                        disabled={collectingId === p.tokenId}
                      >
                        {collectingId === p.tokenId ? (
                          <span>
                            <Loading />
                          </span>
                        ) : (
                          <span> {translate("view.collectFees")}</span>
                        )}
                      </button>
                    )}

                    {/* {p.tokenId && (
                      <button
                        className={`manage-liquidity-btn ms-3 ${
                          collectingId === p.tokenId ? "active" : ""
                        }`}
                        onClick={() => handleViewUncollected(p.tokenId)}
                        disabled={viewingId === p.tokenId}
                      >
                        {viewingId === p.tokenId ? (
                          <Loading />
                        ) : fees ? (
                          "Refresh Uncollected Fees"
                        ) : (
                          "View Uncollected Fees"
                        )}
                      </button>
                    )} */}
                  </div>
                </div>

                <div className="position-extra mt-2">
                  {p.tokenId && (
                    <div className="position-id">
                      <span className="liquidity-pos-id">
                        {translate("remove.tokenId")}
                        {" :"}
                      </span>
                      <span className="liquidity-info-amt">
                        <span>{String(p.tokenId)}</span>
                        <i
                          className="fa fa-copy ms-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleCopy(p.tokenId)}
                        ></i>
                      </span>
                    </div>
                  )}
                </div>

                <div className="manage-all-liquidity mt-2">
                  <div className="liquidty-info">
                    <div className="liquidity-info-title">
                      {translate("view.feeTier")}
                    </div>
                    <div className="liquidity-info-amt">
                      {formatFeeTier(p.feeTier)}
                    </div>
                  </div>

                  <div className="liquidty-info">
                    <div className="liquidity-info-title">
                      {translate("view.addLiquidity")}
                    </div>
                    <div className="liquidity-info-amt">
                      {Number(p.ethwAmount || 0)?.toFixed(4)} ETHW{" / "}
                      {Number(p.tokenAmount || 0)?.toFixed(4)} {p.symbol}
                    </div>
                  </div>

                  {/* {fees && (
                    <div className="liquidty-info">
                      <div className="liquidity-info-title">
                        Uncollected Fees
                      </div>
                      <div className="liquidity-info-amt">
                        {fees?.formatted0 != null
                          ? Number(fees.formatted0)?.toFixed(2)
                          : "0.00"}{" "}
                        ETHW{" / "}
                        {fees?.formatted1 != null
                          ? Number(fees.formatted1)?.toFixed(2)
                          : "0.00"}{" "}
                        {p.symbol}
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default ViewPositionsV3;
